import _slicedToArray from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { useIsomorphicEffect } from '../use-isomorphic-effect/use-isomorphic-effect.js';
var randomId = function randomId() {
  return "mantine-".concat(Math.random().toString(36).slice(2, 11));
};
var useReactId = React["useId".toString()] || function () {
  return void 0;
};
function useClientId() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    uuid = _useState2[0],
    setUuid = _useState2[1];
  useIsomorphicEffect(function () {
    setUuid(randomId());
  }, []);
  return uuid;
}
function getReactId() {
  var id = useReactId();
  return id ? "mantine-".concat(id.replace(/:/g, "")) : "";
}
function useId(staticId) {
  return typeof staticId === "string" ? staticId : getReactId() || useClientId();
}
export { useId };